import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductContinentEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.continents, create: create });
}
export default memo(ProductContinentEditor);
